import React, { useEffect, useState } from "react";
import { InputLabel } from "@mui/material";
import { fetchCommunityDocName } from "../../Services/Community/CommunityAPI/communityApi";
import {
  getDocTypeApi,
  fetchDocumentById,
  updateDocumentApi,
} from "../../Services/DocumentUpload/documentUploadApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { CommunityOwner, SuperAdmin } from "../../Utils/Constant";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const UpdateDocument = () => {
  const [fileName, setFileName] = useState("");

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    community_id: "",
    doc_type: "",
    doc_type_name: "",
    community_documents: null,
  });

  const { data } = useSelector((state) => state.communityDocName);
  const dispatch = useDispatch();
  const [docTypes, setDocTypes] = useState(); // State to store doc types
  const location = useLocation();

  const community_id_for_doc = location.state?.community_id; // Access the state passed
  const document_id = location.state?.document_id; // Access the state passed

  const userType = localStorage.getItem("user_type");

  useEffect(() => {
    dispatch(fetchCommunityDocName());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDocTypeApi())
      .unwrap()
      .then((res) => {
        setDocTypes(res.data);
      })
      .catch((err) => {
        toast.error("Failed to fetch document types.");
      });
  }, [dispatch]);

  const privatetypeId =
    docTypes?.find((type) => type.name === "private")?.id || null;

  const publictypeId =
    docTypes?.find((type) => type.name === "public")?.id || null;

  const handleDocTypeChange = (e, index) => {
    const selectedDocType = e.target.value;
    const doc_type_sel =
      selectedDocType === "private"
        ? privatetypeId
        : selectedDocType === "public"
        ? publictypeId
        : null;
    setFormData((prevState) => ({
      ...prevState,
      doc_type: doc_type_sel,
    }));
  };

  const handleDocTypeNameChange = (e) => {
    const selectedDocNameType = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      doc_type_name: selectedDocNameType,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file.name);
    setFormData((prevState) => ({
      ...prevState,
      community_documents: file,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!document_id) return;
      try {
        const response = await dispatch(
          fetchDocumentById(document_id)
        ).unwrap();
        const docData = response?.data;

        setFormData({
          doc_type:
            docData?.doc_type_display === "private"
              ? privatetypeId
              : publictypeId,
          doc_type_name: docData?.doc_type_name || "",
          community_documents: null,
        });
        setFileName(docData?.community_documents.split("/").pop());
      } catch (error) {
        console.error("Error fetching community data:", error);
      }
    };

    fetchData();
  }, [document_id, dispatch, privatetypeId, publictypeId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const finaldata = new FormData();
    finaldata.append("doc_type", formData.doc_type);
    finaldata.append("doc_type_name", formData.doc_type_name);

    // Check if a new file is selected, otherwise use the previous file reference
    if (formData.community_documents instanceof File) {
      finaldata.append("community_documents", formData.community_documents); // Append the new file
    }
    finaldata.append("community_id", community_id_for_doc);
    dispatch(
      updateDocumentApi({
        document_id: document_id,
        formData: finaldata,
      })
    )
      .unwrap()
      .then((res) => {
        toast.success(" document Updated successfully!");
        if (userType === CommunityOwner) {
          setTimeout(() => {
            navigate("/admin/Admin-community");
          }, 1000);
        }
        if (userType === SuperAdmin) {
          setTimeout(() => {
            navigate("/super-admin/super-admin-community-comp");
          }, 1000);
        }
      })
      .catch((err) => {
        toast.error(" document Updated failed!");
      });
    // }
  };

  return (
    <div>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading create-new">Update Document</div>
          </div>
          <div className="create-community-name-table">
            <div className="create-comm-inner-wrap">
              <div className="upload-docs-block">
                <div className="upload-docs-title">Update Documents</div>
                <form>
                  <div className="mb-4 d-flex file-name-docs-block mt-4 align-items-center ">
                    <div className="doc_type_label child-div">
                      <InputLabel htmlFor="doc_type">Document Type</InputLabel>
                      <div className="radio-group-block d-flex gap-3">
                        <label className="custom-radio ">
                          <input
                            type="radio"
                            id="public"
                            value="public"
                            checked={formData.doc_type === publictypeId}
                            onChange={handleDocTypeChange}
                          />
                          <span className="checkmark-radio"></span>
                          Public
                        </label>
                        <label className="custom-radio ">
                          <input
                            type="radio"
                            id="private"
                            value="private"
                            checked={formData.doc_type === privatetypeId}
                            onChange={handleDocTypeChange}
                          />
                          <span className="checkmark-radio"></span>
                          Private
                        </label>
                      </div>
                    </div>
                    <div className="comm-name-blk child-div">
                      <InputLabel htmlFor="doc_type_name_id">
                        Document Name
                      </InputLabel>

                      <select
                        id={`doc_type_name_id`}
                        name="doc_type_name_id"
                        className="dropdown-box"
                        value={formData.doc_type_name}
                        onChange={handleDocTypeNameChange}
                      >
                        <option value="" disabled selected>
                          Select Document Name
                        </option>

                        {data?.data?.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        )) || null}
                      </select>
                    </div>
                    <div className="d-flex file-name-docs-upload-doc child-div">
                      <div className="">
                        <div className="upload-document">
                          <label htmlFor="upload-file up-docs">
                            Upload Document
                          </label>
                          <div className="file-input-container">
                            <input
                              type="file"
                              id="upload-file"
                              name="upload-file"
                              onChange={handleFileChange}
                              accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                            />
                            <label
                              htmlFor="upload-file"
                              className="file-upload-label up-docs"
                            >
                              <span className="attachment-icon">
                                <svg
                                  width="24"
                                  height="20"
                                  viewBox="0 0 24 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.73897 19.95C5.60156 19.9503 4.48961 19.6133 3.54382 18.9815C2.59803 18.3496 1.86091 17.4515 1.42572 16.4006C0.99054 15.3498 0.876853 14.1934 1.09905 13.0779C1.32124 11.9624 1.86934 10.9379 2.67397 10.134L11.159 1.648C11.2997 1.5073 11.4905 1.42826 11.6895 1.42826C11.8884 1.42826 12.0793 1.5073 12.22 1.648C12.3607 1.78869 12.4397 1.97952 12.4397 2.1785C12.4397 2.37747 12.3607 2.5683 12.22 2.709L3.73397 11.194C3.32314 11.585 2.99471 12.0542 2.76804 12.5741C2.54136 13.0939 2.42103 13.6539 2.41412 14.221C2.40721 14.788 2.51387 15.3508 2.72782 15.876C2.94176 16.4012 3.25866 16.8783 3.65985 17.2792C4.06104 17.68 4.53839 17.9965 5.0638 18.21C5.5892 18.4236 6.15202 18.5297 6.7191 18.5224C7.28618 18.515 7.84605 18.3942 8.36572 18.1671C8.88539 17.94 9.35435 17.6112 9.74497 17.2L20.705 6.24C21.2072 5.72136 21.4854 5.02608 21.4797 4.30414C21.4739 3.58221 21.1845 2.89148 20.674 2.38098C20.1635 1.87048 19.4728 1.58111 18.7508 1.57532C18.0289 1.56952 17.3336 1.84776 16.815 2.35L7.97697 11.194C7.86088 11.3101 7.7688 11.4479 7.70597 11.5996C7.64314 11.7513 7.61081 11.9138 7.61081 12.078C7.61081 12.2422 7.64314 12.4047 7.70597 12.5564C7.7688 12.7081 7.86088 12.8459 7.97697 12.962C8.09306 13.0781 8.23088 13.1702 8.38255 13.233C8.53423 13.2958 8.6968 13.3282 8.86097 13.3282C9.02514 13.3282 9.18771 13.2958 9.33939 13.233C9.49107 13.1702 9.62888 13.0781 9.74497 12.962L15.4 7.306C15.4691 7.23433 15.5519 7.17716 15.6433 7.13781C15.7348 7.09846 15.8332 7.07772 15.9328 7.07681C16.0324 7.0759 16.1312 7.09483 16.2234 7.1325C16.3155 7.17016 16.3993 7.22581 16.4698 7.2962C16.5402 7.36659 16.5959 7.4503 16.6337 7.54245C16.6714 7.63461 16.6905 7.73336 16.6897 7.83294C16.6888 7.93253 16.6682 8.03095 16.6289 8.12247C16.5897 8.21399 16.5326 8.29678 16.461 8.366L10.805 14.023C10.5496 14.2784 10.2465 14.481 9.91279 14.6193C9.57913 14.7576 9.2215 14.8287 8.86032 14.8288C8.49915 14.8288 8.14151 14.7577 7.80781 14.6196C7.47411 14.4814 7.17089 14.2789 6.91547 14.0235C6.66005 13.7681 6.45743 13.465 6.31917 13.1313C6.18091 12.7977 6.10973 12.44 6.10968 12.0789C6.10959 11.3494 6.39926 10.6498 6.91497 10.134L15.755 1.3C16.5519 0.502889 17.6329 0.0550254 18.7601 0.0549317C19.8873 0.0548379 20.9684 0.502521 21.7655 1.2995C22.5626 2.09647 23.0104 3.17746 23.0105 4.30464C23.0106 5.43183 22.5629 6.51289 21.766 7.31L10.806 18.266C10.273 18.8016 9.6392 19.2262 8.94111 19.5153C8.24302 19.8043 7.49454 19.9521 6.73897 19.95Z"
                                    fill="#414141"
                                  />
                                </svg>
                              </span>{" "}
                              <span className="add-attachment-text">
                                Add attachment
                              </span>
                            </label>

                            {fileName && (
                              <div className="mt-2 file-name">{fileName}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-3 add-minus-btns child-div">
                      <div className="add-btn-field">
                        <div
                          className="add-btn-form text-center"
                          onClick={handleSubmit}
                        >
                          Update Document
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateDocument;
